import { lmsFetchAPI } from "../../../../utils/axios";

const STUDENTS_PATH = "/lms/students";

const getErrorMessage = (error, fallback) => error?.response?.data?.error || fallback;
const toApiError = (error, fallback) => ({
  status: error?.response?.status,
  message: getErrorMessage(error, fallback),
});

export const createStudent = async (student) => {
  try {
    const response = await lmsFetchAPI.post(STUDENTS_PATH, student);
    return response.data;
  } catch (error) {
    throw toApiError(error, "Unable to create student");
  }
};

export const getStudents = async () => {
  try {
    const response = await lmsFetchAPI.get(STUDENTS_PATH);
    return response.data;
  } catch (error) {
    throw toApiError(error, "Unable to load students");
  }
};

export const getStudent = async (studentId) => {
  try {
    const response = await lmsFetchAPI.get(`${STUDENTS_PATH}/${studentId}`);
    return response.data;
  } catch (error) {
    throw toApiError(error, "Unable to load student details");
  }
};

export const updateStudent = async (studentId, student) => {
  try {
    const response = await lmsFetchAPI.put(`${STUDENTS_PATH}/${studentId}`, student);
    return response.data;
  } catch (error) {
    throw toApiError(error, "Unable to update student");
  }
};

export const disableStudent = async (studentId) => {
  try {
    const response = await lmsFetchAPI.delete(`${STUDENTS_PATH}/${studentId}`);
    return response.data;
  } catch (error) {
    throw toApiError(error, "Unable to disable student");
  }
};
